import type { ResolverConflitoDialogProps } from "./types-resolver-conflito";
import { useResolverConflitoDialog } from "./use-resolver-conflito";
import { ResolverConflitoDialogView } from "./view-resolver-conflito";

/** Modal "Resolver Conflito de Alocação" do profissional (HU 2434 / US 2040). */
export function ResolverConflitoDialog(props: ResolverConflitoDialogProps) {
  const vm = useResolverConflitoDialog(props);

  return <ResolverConflitoDialogView {...vm} />;
}

export type * from "./types-resolver-conflito";
